import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-1" }

import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { useEmployeeData } from '@/composables/useEmployeeData';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserGroupForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const { employeesAndGroups } = useEmployeeData();

    const employeeOptions = computed(() => {
        return employeesAndGroups.value.keepers || [];
    });

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "name",
      label: "user-groups.form.labels.name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "name",
          modelValue: _ctx.form.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          autocomplete: "name",
          placeholder: _ctx.$t('user-groups.form.labels.name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "user_ids",
      label: "user-groups.form.labels.users"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.user_ids,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.user_ids) = $event)),
          options: employeeOptions.value,
          placeholder: _ctx.$t('user-groups.form.labels.users'),
          "label-by": "name",
          "value-by": "id"
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})